import ProjectSlider from './project-slider';
export default ProjectSlider;